<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">محدوده تایم کاری</h4>
    </div>
    <div class="card-body d-flex justify-content-around">
      <div class="form-check" v-for="(workTime, index) in workTimes" :key="index">
        <input
            class="form-check-input"
            type="radio"
            :id="index"
            :value="workTime"
            v-model="jobQualification.work_time"
        />
        <label class="form-check-label" :for="index">{{ workTime }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      workTimes: {
        fullTime: 'تمام وقت',
        partTime: 'پاره وقت',
        shiftWork: 'شیفتی',
        variable: 'متغیر',
      }
    }
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      },
    },
  }
}
</script>
